import { render } from "./Eventlist.vue?vue&type=template&id=a4184f16"
import script from "./Eventlist.vue?vue&type=script&lang=js"
export * from "./Eventlist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__